import {  useContext } from "react";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import { AppContext } from "components/app/RemExprertProvider";
import SituationPro from "components/app/AuditRemuneration/SituationPro";
import { FaUser } from "react-icons/fa";

const SituationProRemExpressPage = (props) => {
  const context = useContext(AppContext);
  return (
    <>
      <Column fill>
        <Row>
          <Column fill>
            <CardBox bpad>
              <Column fill>
                <Row>
                  <CardBoxHeader icon={<FaUser />}>Situation professionnelle pour {context.state.Prenom}</CardBoxHeader>
                </Row>
                <SituationPro/>
              </Column>
            </CardBox>
          </Column>
        </Row>
      </Column>
    </>
  );
};

export default SituationProRemExpressPage;
